import { Form, Select } from 'antd'
import { NamePath } from 'antd/es/form/interface'
import { FC, ReactNode, useEffect, useMemo, useState } from 'react'
import { EndpointQueryParameters } from '../../../types/strapi/strapi'
import { useScopedContractorsQuery } from '../../../hooks/api/use-scoped-contractors-query'
import { Rule } from 'antd/es/form'
import { SizeType } from 'antd/es/config-provider/SizeContext'

interface ContractorProps {
    name?: NamePath
    label?: ReactNode
    typeName?: string
    rules?: Rule[]
    onChange?: (docId: string) => void
    noStyle?: boolean
}

interface ContractorSelectProps {
    value?: string
    onChange?: (value: string | undefined) => void
    typeName?: string
    extraOnChange?: (docId: string) => void
    size?: 'small' | 'medium' | 'large'
}

const ContractorSelect: FC<ContractorSelectProps> = ({
    value,
    onChange,
    typeName,
    extraOnChange,
    size = 'medium',
}) => {
    const [searchValue, setSearchValue] = useState('')
    const [debouncedSearch, setDebouncedSearch] = useState('')

    useEffect(() => {
        const timer = setTimeout(() => setDebouncedSearch(searchValue), 300)
        return () => clearTimeout(timer)
    }, [searchValue])

    const typeFilter = typeName ?? 'Клиент'

    const params: EndpointQueryParameters = useMemo(() => {
        const filters: Record<string, unknown> = {
            type: { name: { $contains: typeFilter } },
        }

        const trimmed = debouncedSearch.trim()
        if (trimmed) {
            filters.name = { $containsi: trimmed }
        } else if (value) {
            filters.documentId = { $eq: value }
        }

        return {
            filters,
            pagination: { page: 1, pageSize: 50 },
        }
    }, [debouncedSearch, typeFilter, value])

    const { data, isFetching } = useScopedContractorsQuery(params)

    const handleSelectChange = (v: string | undefined) => {
        onChange?.(v)
        if (v !== undefined && v !== null) {
            extraOnChange?.(v)
        }
    }

    return (
        <Select
            placeholder='Клиент'
            style={{ width: '100%' }}
            size={size as SizeType}
            popupMatchSelectWidth={false}
            dropdownStyle={{ minWidth: 'fit-content' }}
            showSearch
            filterOption={false}
            onSearch={setSearchValue}
            loading={isFetching}
            options={data?.data.map(item => ({ value: item.documentId, label: item.name }))}
            value={value}
            onChange={handleSelectChange}
            allowClear
        />
    )
}

const Contractor: FC<ContractorProps> = ({ name, label, typeName, rules, onChange, noStyle }) => {
    return (
        <Form.Item name={name} label={label} rules={rules} noStyle={noStyle}>
            <ContractorSelect typeName={typeName} extraOnChange={onChange} />
        </Form.Item>
    )
}

export { ContractorSelect }
export default Contractor
